import SurveyDeviceInfoCard from "./surveyDeviceInfoCard.container"

export default SurveyDeviceInfoCard;